import { render, staticRenderFns } from "./TetrisPiece.vue?vue&type=template&id=a3ad8c68&scoped=true"
import script from "./TetrisPiece.vue?vue&type=script&lang=js"
export * from "./TetrisPiece.vue?vue&type=script&lang=js"
import style0 from "./TetrisPiece.vue?vue&type=style&index=0&id=a3ad8c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ad8c68",
  null
  
)

export default component.exports